import { put, take, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { filesActionCreators } from '..';
import { createUploadFileChannel } from './createFileUploadChannel';

function* uploadFileSaga(action: ReturnType<typeof filesActionCreators.uploadRequest>) {
  const { url } = action.payload;
  const channel = yield* call(createUploadFileChannel, 'PUT', action.payload);
  while (true) {
    const { progress = 0, err, success } = yield take(channel);
    if (err) {
      yield put(filesActionCreators.uploadFailure({ ...action.payload, error: err }));
      return;
    }
    if (success) {
      yield put(filesActionCreators.uploadSuccess(action.payload));
      if (action.payload.successAction) {
        yield put(action.payload.successAction);
      }
      return;
    }
    yield put(filesActionCreators.uploadProgress({ url, amount: progress }));
  }
}

export function* watchUploadFile() {
  yield takeEvery(filesActionCreators.uploadRequest.match, uploadFileSaga);
}
